export enum GridHeightMultiplier {
  Xs = 1,
  Sx = 1.3725,
  Sm = 1.5,
  Md = 2,
}
